module.exports = __webpack_public_path__ + "img/medal3.89eaf026.svg";